/** Enum representing cookie keys for functional and analytics preferences. */
export enum COOKIES {
  FUNCTIONAL = 'allowFunctionalCookies',
  ANALYTICS = 'allowAnalyticsCookies',
}

/** Type representing the shape of the cookie preferences stored for a user. */
export type CookieConsent = { allowFunctionalCookies: boolean; allowAnalyticsCookies: boolean };

/**
 * All possible cookie configuration actions that can be performed via the cookie banner,
 * including mandatory and user-set options
 */
export type CookieConfigOpt =
  | 'forgetConsentGiven' // functional
  | 'forgetCookieConsentGiven' // analytics
  | 'rememberConsentGiven' // functional
  | 'rememberCookieConsentGiven'; // analytics

/** Type representing a cookie configuration with a list of instructions to apply. */
export type CookieConfig = { instructions: CookieConfigOpt[] };
